// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__YNuiZ","footer":"ModalUpdate_footer__1E0g2"};